import { StyledDialog } from "../../../components/StyledComponents/Dialog/Dialog.js";
import { Box, DialogContent } from "@mui/material";
import {
  BodyMedium,
  H6HeadlineSmall,
  H7TitleLarge,
  H9TitleSmall,
} from "../../../components/StyledComponents/Typography/Typography.tsx";
import { StyledIconButton } from "../../../components/StyledComponents/Buttons/AuradineButtons.js";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useAuth0 } from "@auth0/auth0-react";
import useMinerPageContext from "../../context/useMinerPageContext.js";
import { format, parseISO } from "date-fns";
import { isEmpty } from "lodash";
import { useTheme } from "../../../ThemeContext/ThemeContext.js";

const PoolsHeader = ({ setOpen }) => {
  const { colors } = useTheme();
  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
      flexGrow={1}
      padding={"1.5rem 0"}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        gap={2}
      >
        <H6HeadlineSmall>
          {"Pools Information"}
        </H6HeadlineSmall>

        <BodyMedium>
          Use this window to view the pools attached to the
          miners and their status.
        </BodyMedium>
      </Box>

      <StyledIconButton
        colors={colors}
        onClick={() => {
          setOpen(false);
        }}
      >
        <CloseIcon />
      </StyledIconButton>
    </Box>
  );
};

const PoolsForm = ({ setOpen, poolInformation }) => {
  const [authToken, setAuthToken] = useState("");
  const { getAccessTokenSilently } = useAuth0();
  const { colors } = useTheme();
  return (
    <>
      <PoolsHeader setOpen={setOpen} />
      <Box display={"flex"} flexGrow={1}>
        <Box
          display={"flex"}
          flexDirection={"column"}
          flexGrow={1}
          gap={2}
          padding={"0 1.5rem 1.5rem 1.5rem"}
        >
          {poolInformation.map((pool, index) => (
            <Box
              display={"grid"}
              gridTemplateColumns={"1fr"}
              gap={"1.5rem"}
              sx={{
                padding: "1.25rem 2rem 2rem 2rem",
                borderRadius: "1.5rem",
                backgroundColor: colors.background.accent,
              }}
            >
              <H7TitleLarge>{pool.PoolName}</H7TitleLarge>
              {!isEmpty(pool) &&
              Object.entries(pool).length > 0 ? (
                Object.entries(pool)
                  .filter(
                    ([key, value]) => key !== "PoolName"
                  )
                  .map(([key, value]) => (
                    <Box
                      display={"grid"}
                      gridTemplateColumns={"1fr 3fr"}
                      key={key}
                    >
                      <H9TitleSmall>{key}:</H9TitleSmall>
                      <BodyMedium>{value}</BodyMedium>
                    </Box>
                  ))
              ) : (
                <BodyMedium>No data available</BodyMedium>
              )}
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};

const PoolsDialog = ({ open, setOpen }) => {
  const { poolsData } = useMinerPageContext();
  const poolDataToBeDisplayed = poolsData || [];
  console.log("Pool Data", poolsData);
  const pool1Status = !isEmpty(poolsData)
    ? poolsData.Pool1Status
    : "N/A";
  const pool2Status = !isEmpty(poolsData)
    ? poolsData.Pool2Status
    : "N/A";
  const pool3Status = !isEmpty(poolsData)
    ? poolsData.Pool3Status
    : "N/A";
  const Pool1URL = !isEmpty(poolsData)
    ? poolsData.Pool1URL
    : "N/A";
  const Pool2URL = !isEmpty(poolsData)
    ? poolsData.Pool2URL
    : "N/A";
  const Pool3URL = !isEmpty(poolsData)
    ? poolsData.Pool3URL
    : "N/A";
  const Pool1User = !isEmpty(poolsData)
    ? poolsData.Pool1User
    : "N/A";
  const Pool2User = !isEmpty(poolsData)
    ? poolsData.Pool2User
    : "N/A";
  const Pool3User = !isEmpty(poolsData)
    ? poolsData.Pool3User
    : "N/A";
  // Only show Protocol if URL exists (not empty)
  const Pool1Protocol = !isEmpty(poolsData) && poolsData.Pool1URL
    ? (poolsData.Pool1Protocol || "NA")
    : null;
  const Pool2Protocol = !isEmpty(poolsData) && poolsData.Pool2URL
    ? (poolsData.Pool2Protocol || "NA")
    : null;
  const Pool3Protocol = !isEmpty(poolsData) && poolsData.Pool3URL
    ? (poolsData.Pool3Protocol || "NA")
    : null;
  const poolInformationData = [
    {
      PoolName: "Pool 1",
      URL: Pool1URL,
      User: Pool1User,
      ...(Pool1Protocol && { Protocol: Pool1Protocol }),
      Status: pool1Status,
    },
    {
      PoolName: "Pool 2",
      URL: Pool2URL,
      User: Pool2User,
      ...(Pool2Protocol && { Protocol: Pool2Protocol }),
      Status: pool2Status,
    },
    {
      PoolName: "Pool 3",
      URL: Pool3URL,
      User: Pool3User,
      ...(Pool3Protocol && { Protocol: Pool3Protocol }),
      Status: pool3Status,
    },
  ];

  const { colors } = useTheme();

  return (
    <StyledDialog
      colors={colors}
      maxWidth={"md"}
      fullWidth
      open={open}
      hideBackdrop
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          setOpen(false);
        }
      }}
    >
      <DialogContent sx={{ padding: 0 }}>
        <PoolsForm
          setOpen={setOpen}
          poolInformation={poolInformationData}
        />
      </DialogContent>
    </StyledDialog>
  );
};

export default PoolsDialog;
